const getLocationSkuHistoryQuery = `
/*
  We first get counts from stock count table
*/
with 
count_events as (
  select
  sl.sku,
  sl.partner_balance,
  sl.sl_balance,
  sl.sold,
  null::int as delivered,
  sl.closing,
  s.submitted_at as date,
  s.updated_by as driver,
  case when not partial_count then 'stock_count' else 'stock_count_adjustment' end  as event_type,
  null as status,
  s.stock_count_id as event_id,
  null::varchar as shipment_number,
  sl.notes as notes
  from avocado.data_stockcount s
  left join avocado.data_stockcountline sl on s.id = sl.stock_count_id
  where s.fs_id = $1
  and sl.sku = $2
),
/*
  Then we get sent shipments
*/
shipments_sent as (
  select
    dsl.origin_sku as sku,
    null::int as partner_balance,
    null::int as sl_balance,
    null::int as sold,
    coalesce(
      -dssl_received.amount,
      -dssl_sent.amount
    ) as delivered,
    coalesce(
      -dssl_received.amount,
      -dssl_sent.amount
    ) as closing,
    coalesce(dss_sent.created_at, ds.updated_at) as date,
    coalesce(dss_sent.created_by, ds.updated_by) as driver,
    'shipment' as event_type,
    ds.status,
    ds.shipment_id as event_id,
    ds.shipment_number as shipment_number,
    null::text as notes
  from avocado.data_shipment ds
  left join avocado.data_shipmentline dsl on dsl.shipment_id = ds.id
  left join avocado.data_shipmentsnapshot dss_sent
    on dss_sent.shipment_id = ds.shipment_id and dss_sent.status = 'sent'
  left join avocado.data_shipmentsnapshotline dssl_sent
    on dssl_sent.shipment_snapshot_id = dss_sent.id and dssl_sent.sku = dsl.origin_sku
  left join avocado.data_shipmentsnapshot dss_received
    on dss_received.shipment_id = ds.shipment_id and dss_received.status = 'received'
  left join avocado.data_shipmentsnapshotline dssl_received
    on dssl_received.shipment_snapshot_id = dss_received.id and dssl_received.sku = dsl.destination_sku
  where ds.origin_id = $1
    and dsl.origin_sku = $2
    and ds.status in ('sent', 'arrived', 'received')
    and coalesce(dssl_received.amount, dssl_sent.amount) is not null
  order by ds.created_at desc
),
/*
  Then we get received shipments
*/
shipments_received as (
  select
    dsl.destination_sku as sku,
    null::int as partner_balance,
    null::int as sl_balance,
    null::int as sold,
    dsl.amount as delivered,
    dsl.amount as closing,
    dss.created_at as date,
    dss.created_by as driver,
    'shipment' as event_type,
    ds.status,
    ds.shipment_id as event_id,
    ds.shipment_number as shipment_number,
    null::text as notes
  from avocado.data_shipment ds
  left join avocado.data_shipmentline dsl on dsl.shipment_id = ds.id
  left join avocado.data_shipmentsnapshot dss on dss.shipment_id = ds.shipment_id and dss.status = 'received'
  where ds.destination_id = $1
  and destination_sku = $2
  and ds.status = 'received'
  order by ds.created_at desc
),
/*
  Then we union both to build a single shipments cte
*/
shipments as (
  select * from shipments_sent
  union all
  select * from shipments_received
),
/*
  Then we merge with shipments to create a timeline of stock activity. We also craft a partiton window using count dates
*/
stock_activity as (
  select 
    *,
    date as partition_window
  from count_events
  union all
  select 
    *,
  (select count_events.date from count_events where shipments.date > count_events.date order by count_events.date desc limit 1) as partition_window 
  from shipments
  where date is not null
),
/*
  We figure out current openings
*/
running_totals as (
  select 
    sum(closing) over (
      partition by partition_window
      order by date ) as running_total,
    *
  from stock_activity
  order by date desc
)
/*
  Tying it all together
*/
select
  sku,
  date,
  event_type,
  event_id,
  driver,
  status,
  sold,
  delivered,
  sl_balance,
  partner_balance,
  shipment_number,
  notes,
  running_total AS current_opening,
  LAG(running_totals.running_total, 1) OVER (ORDER BY running_totals.date) AS prev_opening
from running_totals
order by date;
`
module.exports = getLocationSkuHistoryQuery
